export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8095.15bf7b06.jpg";